
  // import { stringify } from "querystring";
import React, { Fragment,useState,useCallback } from "react";
  import {CopyToClipboard} from 'react-copy-to-clipboard';
  const  CopyPaste = (data) =>{
    const [responseVal, setResponseVal] = useState(data);
    const [value, setValue] = useState("");
    const [copied, setCopied] = useState(false);
    const onChange = useCallback(({target: {value}}) => {
      //setValue(value);
    }, [])
    const onCopy =useCallback(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1000);
    }, [])
    
    return (
      <div className="app">
        <section className="section" style={{display: "flex"}}>
          <CopyToClipboard onCopy={onCopy} text={responseVal?.data??null}>
            <button className="btn btn-xs btn-primary">Copy</button>
          </CopyToClipboard>
          {copied ? <span style={{color: 'green'}}>Copied.</span> : null}
        </section>
      </div>
    );
}
export default CopyPaste;
  
  